export default __webpack_public_path__ + "static/media/guardian-telematics.0273f4e4.png";